import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import Navigation from "../components/home/Navigation";
import HeroSection from "../components/home/HeroSection";
import ProductsSection from "../components/home/ProductsSection";
import ServicesSection from "../components/home/ServicesSection";
import TeamSection from "../components/home/TeamSection";
import AboutSection from "../components/home/AboutSection";
import ContactSection from "../components/home/ContactSection";
import Footer from "../components/home/Footer";
import DynamicBackground from "../components/home/DynamicBackground";
import { translations } from "../components/home/translations";

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');
  const [language, setLanguage] = useState('en');
  const texts = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'products', 'services', 'team', 'about', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-black text-white min-h-screen relative">
      <Navigation 
        activeSection={activeSection} 
        scrollToSection={scrollToSection} 
        language={language}
        setLanguage={setLanguage}
        texts={texts.navigation}
      />
      
      <main className="relative z-10">
        <HeroSection scrollToSection={scrollToSection} texts={texts.hero} />
        <ProductsSection texts={texts.products} />
        <ServicesSection texts={texts.services} />
        <TeamSection texts={texts.team} />
        <AboutSection texts={texts.about} />
        <ContactSection texts={texts.contact} />
      </main>

      <Footer texts={texts.footer} />

      {/* Enhanced Background elements */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <DynamicBackground />
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/80 to-black/90" />
        <div className="absolute top-0 left-1/3 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/3 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
      </div>
    </div>
  );
}
